import gsap from 'gsap'

class Home {
  constructor() {
    this.page = document.querySelector('.template-home')
    if (!this.page) return

    this.slides = this.page.querySelectorAll('.slide')
    if (this.slides.length <= 1) return

    this.current = 0
    gsap.set(this.slides[0], { opacity: 1 })

    setInterval(() => this.next(), 4500)
  }

  next() {
    const prev = this.current
    this.current = (this.current + 1) % this.slides.length

    gsap.to(this.slides[this.current], {
      opacity: 1,
      duration: 1.5,
      ease: 'power2.inOut',
    })
    gsap.to(this.slides[prev], {
      opacity: 0,
      duration: 1.5,
      ease: 'power2.inOut',
      delay: 0.2,
    })
  }
}

export { Home }
